// @flow
import {
  DELETE_TEST_LOADING,
  DELETE_TEST_SUCCESS,
  DELETE_TEST_ERROR,
  ADD_TEST_LOADING,
  ADD_TEST_SUCCESS,
  ADD_TEST_ERROR,
  UPDATE_TEST_LOADING,
  UPDATE_TEST_SUCCESS,
  UPDATE_TEST_ERROR,
  UPDATE_HIV_MOTHER_STATUS_LOADING,
  UPDATE_HIV_MOTHER_STATUS_SUCCESS,
  UPDATE_HIV_MOTHER_STATUS_ERROR,
  UPDATE_TB_MOTHER_STATUS_LOADING,
  UPDATE_TB_MOTHER_STATUS_SUCCESS,
  UPDATE_TB_MOTHER_STATUS_ERROR,
} from '../actions/testingActions';

export default (state: Object = {}, action: Object) => {
  switch (action.type) {
    case DELETE_TEST_LOADING:
    case ADD_TEST_LOADING:
    case UPDATE_TEST_LOADING:
    case UPDATE_HIV_MOTHER_STATUS_LOADING:
    case UPDATE_TB_MOTHER_STATUS_LOADING:
      return {
        ...state,
        status: 'LOADING',
      };
    case DELETE_TEST_SUCCESS:
    case ADD_TEST_SUCCESS:
    case UPDATE_TEST_SUCCESS:
    case UPDATE_HIV_MOTHER_STATUS_SUCCESS:
    case UPDATE_TB_MOTHER_STATUS_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        data: action.data,
      };
    case DELETE_TEST_ERROR:
    case ADD_TEST_ERROR:
    case UPDATE_TEST_ERROR:
    case UPDATE_HIV_MOTHER_STATUS_ERROR:
    case UPDATE_TB_MOTHER_STATUS_ERROR:
      return {
        ...state,
        status: 'ERROR',
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/testingReducer.js